import { render } from "./Sidebar.vue?vue&type=template&id=60ef2d09"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sidebar/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60ef2d09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60ef2d09', __exports__)) {
    api.reload('60ef2d09', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=60ef2d09", () => {
    api.rerender('60ef2d09', render)
  })

}


export default __exports__